import React from "react";
import "../styles/Products.css";

import OfferbeezImg from "../assets/Offerbeez_product_image_.jpeg";
import CommunityConnectImg from "../assets/community_cconnect_product.png";
import PurohitImg from "../assets/Samvarta.png";
import SharedCards from "../assets/sharecards.png";
import CouponsImg from "../assets/Coupons_projduct_image.jpeg";
import SeekopinionImg from "../assets/OPINIX.png";
import MCGuruImg from '../assets/m_c_guru.jpeg';

const Products = () => {
  return (        
    <section className="products" id="products">
      <h2 data-aos="fade-up">Our Products</h2>

      {/* === Main Project Highlight === */}
      <div
        className="main-product"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <a
          href="https://offerbeez.in/"
          className="main-product-card"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="main-product-image">
            <img src={OfferbeezImg} alt="OfferBeez" />
          </div>
          <div className="main-product-info">
            <h3>OfferBeez – ONE PLATFORM ENDLESS PROMOTIONS</h3>
            <p>
              Connecting businesses and customers through real-time deals.
              Driving growth, savings, and stronger communities.
            </p>
            <div className="animated-arrow" title="Explore OfferBeez">
              <span className="arrow-text">Explore Now</span>
              <span className="arrow-icon">➜</span>
            </div>
          </div>
        </a>
      </div>

      {/* === Upcoming Projects Section === */}
      <h2 className="upcoming-title" data-aos="fade-up">
        Upcoming Product Ideas
      </h2>

      <div className="product-grid">
        {/* Coupons */}
        <div className="product-card" data-aos="fade-up" data-aos-delay="200">
          <div className="product-image">
            <img src={CouponsImg} alt="Coupons" />
          </div>
          <div className="product-info">
            <h3>Coupons</h3>
            <div className="divider"></div>
          </div>
        </div>

        {/* Seek Opinion */}
        <div className="product-card" data-aos="fade-up" data-aos-delay="300">
          <div className="product-image">
            <img src={SeekopinionImg} alt="Seek Opinion" />
          </div>
          <div className="product-info">
            <h3>Opinix</h3>
            <div className="divider"></div>
          </div>
        </div>

        {/* Community Connect */}
        <div className="product-card" data-aos="fade-up" data-aos-delay="400">
          <div className="product-image">
            <img src={CommunityConnectImg} alt="Community Connect" />
          </div>
          <div className="product-info">
            <h3>Community Connect</h3>
            <div className="divider"></div>
          </div>
        </div>

        {/* Purohit */}
        <div className="product-card" data-aos="fade-up" data-aos-delay="500">
          <div className="product-image">
            <img src={PurohitImg} alt="Purohit" />
          </div>
          <div className="product-info">
            <h3>Samvarta</h3>
            <div className="divider"></div>
          </div>
        </div>

        {/* WOM */}
        <div className="product-card" data-aos="fade-up" data-aos-delay="600">
          <div className="product-image">
            <img src={SharedCards} alt="Shared cards" />
          </div>
          <div className="product-info">
            <h3>Shared Cards</h3>
            <div className="divider"></div>
          </div>
        </div>

        {/* M-C Guru */}
        <div className="product-card" data-aos="fade-up" data-aos-delay="700">
          <div className="product-image">
            <img src={MCGuruImg} alt="My Career Guru" />
          </div>
          <div className="product-info">
            <h3>My Career Guru (M-C Guru)</h3>
            <div className="divider"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;